import React from 'react';
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeflex/primeflex.css"
import './styles/layout.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import LoginPage from "./pages/LoginPage";
import EmployeesPage from "./pages/EmployeesPage";
import ExpensesPage from "./pages/ExpensesPage";
import LeavesPage from "./pages/LeavesPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import ManagementPage from "./pages/ManagementPage";
import CandidateManagementPage from "./pages/CandidateManagementPage";

// 🛡️ Private route import
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <PrimeReactProvider>

      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProfilePage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/expenses" element={<ExpensesPage />} />
            <Route path="/leaves" element={<LeavesPage />} />

            {/* 🔐 Admin rolü */}
            <Route
              path="/admin"
              element={
                <PrivateRoute allowedRoles={['admin']}>
                  <AdminPage />
                </PrivateRoute>
              }
            />

            {/* 🔐 Admin + Manager rolü */}
            <Route
              path="/management"
              element={
                <PrivateRoute allowedRoles={['admin', 'manager']}>
                  <ManagementPage />
                </PrivateRoute>
              }
            />
              {/* 🔐 Admin + Manager rolü */}
            <Route
              path="/candidates"
              element={
                <PrivateRoute allowedRoles={['admin', 'manager']}>
                  <CandidateManagementPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </PrimeReactProvider>
  );
}

export default App;
